<template>
    <div class="TracesSection">
        <TracesTable
            ref="tracesTable"
            :isLoading="isLoading"
            :filteredTraces="filteredTraces"
            :processId="processId"
            :caseId="caseId"
            :search="search"
            @preview-trace="handlePreviewTrace"
        />

        <AttributeSelector
            ref="attrSelector"
            :attrs="attributes"
            @export="handleDownload"
            @exportExtended="handleDownloadExtended"
        />

        <TracePreviewDialog
            :show="previewShown"
            :processId="processId"
            :traceKey="previewTraceKey"
            @close="previewShown = false"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import {
    Api, apiRequest, notifyError, notifySuccess,
} from '@/api'
import { filtersStorageMixin } from '@/mixins'
import { download } from '@/services/download'
import TracesTable from './components/TracesTable.vue'
import AttributeSelector from './components/AttributeSelector.vue'
import TracePreviewDialog from './components/TracePreviewDialog.vue'

export default {
    name: 'TracesSection',
    components: { TracesTable, AttributeSelector, TracePreviewDialog },
    mixins: [filtersStorageMixin],
    props: {
        processId: VueTypes.oneOfType([VueTypes.string, VueTypes.number]),
        filteredTraces: VueTypes.oneOfType([VueTypes.string, VueTypes.number]),
        attributes: VueTypes.array,
    },
    data() {
        return {
            isLoading: false,
            caseId: undefined,
            search: '',
            previewShown: false,
            previewTraceKey: undefined,
        }
    },
    beforeMount() {
        // if (this.$route.params.selectedCaseId) {
        //     this.caseId = this.$route.params.selectedCaseId
        // }
    },
    created() {
        if (sessionStorage) {
            const selectedCaseId = sessionStorage.getItem('selectedCaseId')
            this.caseId = selectedCaseId && selectedCaseId !== 'null' ? selectedCaseId : undefined
        }
    },
    mounted() {
    },
    unmounted() {
        sessionStorage.removeItem('selectedCaseId')
    },
    methods: {
        async generateDataset(name) {
            const datasetId = this.processId
            const params = this.buildVisualizationParams({ name })
            notifySuccess(this.$t('visualization.traces.creatingDataset'))
            apiRequest(Api().datasets.createChild({ datasetId, params }))
                .then(() => {
                    notifySuccess(this.$t('visualization.traces.datasetCreated'))
                })
                .catch(notifyError)
        },
        openExport() {
            this.$refs.attrSelector.open()
        },

        applySearch(search) {
            this.search = search || ''
            this.$refs.tracesTable?.applySearch?.(this.search)
        },
        handleDownload(selAttrs) {
            this.isLoading = true
            notifySuccess(this.$t('visualization.traces.downloadStarted'))
            const attributes = selAttrs
            apiRequest(Api().visualizations.downloadTraces({
                processId: this.processId,
                params: this.buildVisualizationParams({ attributes }),
            }))
                .then((data) => {
                    download({ name: this.processId, data })
                    notifySuccess(this.$t('visualization.traces.downloadOK'))
                })
                .catch(notifyError)
                .finally(() => { this.isLoading = false })
        },
        handleDownloadExtended(selAttrs) {
            this.isLoading = true
            notifySuccess(this.$t('visualization.traces.downloadStarted'))
            const attributes = selAttrs
            apiRequest(Api().visualizations.downloadExtendedTraces({
                processId: this.processId,
                params: this.buildVisualizationParams({ attributes }),
            }))
                .then((data) => {
                    download({ name: this.processId, data })
                    notifySuccess(this.$t('visualization.traces.downloadOK'))
                })
                .catch(notifyError)
                .finally(() => { this.isLoading = false })
        },
        handlePreviewTrace({ traceKey } = {}) {
            if (!traceKey) return
            this.previewTraceKey = traceKey
            this.previewShown = true
        },
    },
}
</script>
<style scoped lang="scss">
.TracesSection {
    width: 100%;
}

</style>
